import {
  ACTION_BARCODE_END,
  ACTION_BARCODE_START,
  BARCODE_SCAN,
  BARCODE_REG,
  CHANGE_BARCODE_STATE_LOCAL,
} from '../actions/barCodeScan/barCodeScan.actiontype';

const initialState = {
  isProcessing: false,
  barCodeScan: '',
  barCodeReg: '',
};

const BarCodeData = (state = initialState, action) => {
  switch (action.type) {
    case ACTION_BARCODE_START:
      return {
        ...state,
        isProcessing: true,
      };

    case ACTION_BARCODE_END: {
      return {
        ...state,
        isProcessing: false,
      };
    }
    case BARCODE_SCAN:
      return {
        ...state,
        barCodeScan: action.payload,
        isProcessing: false,
      };
    case BARCODE_REG: {
      return {
        ...state,
        barCodeReg: action.payload,
        isProcessing: false,
      };
    }
    case CHANGE_BARCODE_STATE_LOCAL: {
      return {
        ...state,
        barCodeReg: 'Reset',
        barCodeScan: 'Reset',
        isProcessing: false,
      };
    }
    default:
      return state;
  }
};

export default BarCodeData;

const FILE_VERSION = process.env.REACT_APP_FILE_VERSION;
